import { } from 'react';
import { useNavigate } from 'react-router-dom';
import { Timer, Ruler, Activity, Database, Shield, CreditCard } from 'lucide-react';
import { useAuthStore } from '../stores/authStore';

const DashboardPage = () => {
  const navigate = useNavigate();
  const { user, isAdmin } = useAuthStore();

  const features = [
    {
      name: 'スピード分析',
      description: '走行速度を計測し、パフォーマンスを分析',
      icon: Timer,
      href: '/speed',
      color: 'bg-red-500',
    },
    {
      name: 'ピッチ/ストライド分析',
      description: 'ピッチとストライドのバランスを確認',
      icon: Ruler,
      href: '/pitch',
      color: 'bg-blue-500',
    },
    {
      name: '接地/滞空分析',
      description: '接地時間と滞空時間を計測',
      icon: Activity,
      href: '/contact',
      color: 'bg-green-500',
    },
    {
      name: 'データ管理',
      description: '測定結果の履歴を確認・管理',
      icon: Database,
      href: '/settings',
      color: 'bg-purple-500',
    },
    {
      name: 'サブスクリプション',
      description: 'サブスクリプションの管理',
      icon: CreditCard,
      href: '/subscription',
      color: 'bg-indigo-500',
    },
  ];

  // 管理者用の機能を追加
  if (isAdmin) {
    features.push({
      name: '管理者ページ',
      description: 'ユーザー管理と承認',
      icon: Shield,
      href: '/new-admin',
      color: 'bg-gray-700',
    });
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-primary-600 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold text-white mb-4">
            Sprint Analysis
          </h1>
          <p className="text-xl text-primary-100">
            スプリントパフォーマンスを科学的に分析
          </p>
          {user?.organization && (
            <p className="mt-2 text-lg text-primary-200">
              {user.organization}
            </p>
          )}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature) => (
            <div
              key={feature.name}
              onClick={() => navigate(feature.href)}
              className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer transform transition-transform hover:scale-105"
            >
              <div className={`${feature.color} p-6`}>
                <feature.icon className="h-8 w-8 text-white" />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {feature.name}
                </h3>
                <p className="text-gray-600">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;